import ipad from 'marketing-website/media/images/pages/sketchpad/ipad-sketch-pad.pdf';
import iphone4 from 'marketing-website/media/images/pages/sketchpad/iphone4-sketch-pad.pdf';
import iphone5 from 'marketing-website/media/images/pages/sketchpad/iphone5-sketch-pad.pdf';
import iphone6 from 'marketing-website/media/images/pages/sketchpad/iphone6-sketch-pad.pdf';
import iphone6Plus from 'marketing-website/media/images/pages/sketchpad/iphone6plus-sketch-pad.pdf';
import nexus5 from 'marketing-website/media/images/pages/sketchpad/nexus5-sketch-pad.pdf';

import assets from './assets.js';

const pdfs = [
  {
    id: 0,
    name: 'iPhone 6',
    asset: assets.iphone6,
    file: iphone6,
  },
  {
    id: 1,
    name: 'iPhone 6 Plus',
    asset: assets.iphone6Plus,
    file: iphone6Plus,
  },
  {
    id: 2,
    name: 'iPad',
    asset: assets.ipad,
    file: ipad,
  },
  {
    id: 3,
    name: 'iPhone 4',
    asset: assets.iphone4,
    file: iphone4,
  },
  {
    id: 4,
    name: 'iPhone 5',
    asset: assets.iphone5,
    file: iphone5,
  },

  {
    id: 5,
    name: 'Nexus 5',
    asset: assets.nexus5,
    file: nexus5,
  },
];

export default pdfs;



// WEBPACK FOOTER //
// ./src/configs/pages/sketchpad/pdf.js